/**
 * How much extra time one should wait to be sure the previous animation completed
 * @type {number} Milliseconds
 */
export const THROTTLE_SAFETY = 100

/**
 * The number of milliseconds a standard duration controlled interactive animation should take
 * @type {number}
 */
export const BASE_INTERACTION_DURATION = 500
